// import RepositoryFactory from "@/apis";
// const hoc = RepositoryFactory.hoc;

import partners from "../../apis/partners";

export default {
  createPartners({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await partners.createPartners(payload);
        // console.log(data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getPartners({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await partners.getPartners(payload);
        commit("SET_PARTNERS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updatePartners({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await partners.updatePartners(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deletePartners({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await partners.deletePartners(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
